import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CorpAdminConstants {
  //task management page
  taskTableTitle: string = 'Facility Checklist Items';
  taskTableEmpty: string =
    'Click ‘+’ button in top right-hand corner to create new Facility Checklist Item';
  trueChip: string = 'True';
  falseChip: string = 'False';

  //Breadcrumbs
  breadCrumbHome: string = 'Facility Checklist Items';
  breadCrumbNewTask: string = 'Create New Task Item';
  breadCrumbEditTask: string = 'Edit Task Item';

  //NewEdit Task Page
  taskNameTitle: string = 'Task Name:';
  taskNamePlaceholder: string = 'Add Task Name Here...';
  requiredTitle: string = 'Required:';
  categoriesTitle: string = 'Categories:';
  codesTitle: string = 'Standard Codes:';
  codeValueTitle: string = 'Standard Code:';
  codeValuePlaceholder: string = 'Select Code...';
  deptTitle: string = 'Departments:';
  primaryDeptTitle: string = 'Primary Department:';
  primaryDeptPlaceholder: string = 'Set Primary Department...';
  unassignedTitle: string = 'Unassigned';
  assignedTitle: string = 'Assigned';
  emptyAssignedDepts: string = 'Drag and Drop Departments Here for Assignment';
  emptyUnassignedDepts: string = 'All Departments Assigned to Task';

  //tooltips
  disableSaveTooltip: string =
    'You must have all required fields before saving: Task Name, at least one Category, at least one Department, and an assigned Primary Department.';
  primaryDeptTooltip: string =
    'The Primary Department selected will be the default department assigned in the backend on all defects found on this task.';

  //Toggles
  CCItoggle: string = 'CCI';
  AOCtoggle: string = 'AOC';
  CQItoggle: string = 'CQI';
  QSItoggle: string = 'QSI';
  ebuiltToggle: string = 'eBuilt';
  ebuiltPlusToggle: string = 'eBuilt Plus';

  //dropdownTypes
  codeDropDown: string = 'standardCode';
  primaryDropDown: string = 'primaryDepartment';

  //Buttons
  saveButton: string = 'Save';
  cancelButton: string = 'Cancel';
}
